module.exports = __webpack_public_path__ + "static/media/edit.1c62003a.svg";